import FlagDetailContainer from "./FlagDetailContainer";
export default FlagDetailContainer;
